import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BaseDetails from 'containers/Base/BaseDetails.js';
import { closeDetails, openDetails, toggleModal } from 'reducers/ui';
import PropTypes from 'prop-types';
import {
  tripTypeGridActions,
  tripTypeNS,
  tripTypeSelectors,
} from 'containers/Pages/Tasks/TripTypes';

const TripTypeDetails = ({ id, editable, toggleEditMode, cancel }) => {
  //------------------------------Selectors---------------------------------
  const loading = useSelector(state => state.ui.loading);

  const details = useSelector(state =>
    tripTypeSelectors.getTripTypeDetailsTransformed(state),
  );
  //-----------------------Actions------------------------------------------
  const dispatch = useDispatch();
  const dispatchFetchTripTypeDetails = useCallback(
    id => dispatch(tripTypeGridActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchOpenDetails = useCallback(url => dispatch(openDetails(url)), [
    dispatch,
  ]);
  const dispatchClearTripTypeDetails = useCallback(
    () => dispatch(tripTypeGridActions.setGridRowDetails({})),
    [dispatch],
  );

  const dispatchToggleModal = useCallback(
    nameSpace => dispatch(toggleModal(nameSpace)),
    [dispatch],
  );
  //------------------------------------------------------------------------
  useEffect(() => {
    dispatchFetchTripTypeDetails(id);
    dispatchOpenDetails(tripTypeNS);
    return () => {
      dispatchClearTripTypeDetails();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onEdit = () => {
    toggleEditMode();
    dispatchToggleModal(tripTypeNS);
  };
  const cancelDetails = () => {
    cancel();
    closeDetails(tripTypeNS);
  };
  return (
    <BaseDetails
      header={'Trip Type'}
      cancel={cancelDetails}
      editable={editable}
      onEdit={onEdit}
      details={details}
      loading={loading}
    />
  );
};
TripTypeDetails.propTypes = {
  cancel: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  id: PropTypes.string,
  loading: PropTypes.bool,
  toggleEditMode: PropTypes.func,
};

export default TripTypeDetails;
